import { render, staticRenderFns } from "./PayConsultation.vue?vue&type=template&id=0cd9073a&scoped=true&"
import script from "./PayConsultation.vue?vue&type=script&lang=js&"
export * from "./PayConsultation.vue?vue&type=script&lang=js&"
import style0 from "./PayConsultation.vue?vue&type=style&index=0&id=0cd9073a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9073a",
  null
  
)

export default component.exports